import { useAtom } from "jotai";
import React from "react";
import { MenuItem } from "../components/Menu";
import { currentUserAtom } from "../jotai/atoms";
import { MapClient } from "@roomservice/react";
import { AnyBlock } from "../types";
import { ROOM_SERVICE_MAP_KEYS } from "../consts";
import { useRoomClient } from "../roomservice/utils";
import { importBlocks } from "./useStarterBlocks";

export function handleDroppedBlockData(
  upsertBlock: (block: Partial<AnyBlock>) => void,
  e: DragEvent,
  items: DataTransferItemList
) {
  let reader = new FileReader();
  reader.onloadend = function () {
    try {
      const data = JSON.parse((this.result || "{}").toString());
      importBlocks(data, upsertBlock);
    } catch (e) {
      console.error("unknown file drop", e);
    }
  };

  let file = e.dataTransfer?.files[0];
  if (file && items[0].type.includes("json")) reader.readAsText(file);
}

export default function ExportJSON() {
  const [currentUser] = useAtom(currentUserAtom);
  const room = useRoomClient();

  if (!currentUser) return null;

  let exportJSON = () => {
    if (!room) return;
    const bIds: MapClient<Record<string, string>> = room.map(
      ROOM_SERVICE_MAP_KEYS.BLOCKIDS
    );
    let blocks: any = {};

    for (let index in bIds["keys"]) {
      let blockId = bIds["keys"][index];
      const b: MapClient<AnyBlock> = room.map(blockId);
      const retrievedBlock = b.toObject();
      blocks[retrievedBlock.id] = retrievedBlock;
    }

    let a = document.createElement("a");
    let json = JSON.stringify(blocks),
      blob = new Blob([json], { type: "octet/stream" }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "blocks.json";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return <MenuItem onSelect={exportJSON}>Export blocks as JSON</MenuItem>;
}
